<template>
	<ChalkyUtilitySettingsPanel
		ref="settingsPanel"
		v-bind:tabs="settingsTabs"
		v-bind:value="settingsTab"
		v-on:input="Handle_OnTabChange"
	>
		<!-- About Tab Content -->
		<template v-slot:about>
			<div class="default-content">
				<h2 class="color-chalky-white">ChalkySticks Pad</h2>
				<p>v{{ version }}</p>

				<p class="type-large-paragraph" style="margin-top: 2rem">
					Create and share pool shot diagrams
					<br />
					with precision and style.
				</p>

				<hr />

				<p>
					Have feedback?
					<a href="mailto:feedback@chalkysticks.com">We'd love to hear it</a>
				</p>
			</div>
		</template>

		<!-- Settings Tab Content -->
		<template v-slot:settings>
			<div class="default-content">
				<h3>Settings</h3>
				<p>Coming soon.</p>
			</div>
		</template>

		<!-- Diagrams Tab Content -->
		<template v-slot:diagrams>
			<div class="default-content">
				<h3>Diagrams</h3>
				<p>Coming soon.</p>
			</div>
		</template>
	</ChalkyUtilitySettingsPanel>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop, Ref } from 'vue-property-decorator';

	/**
	 * Settings panel for the pad creator with About, Settings, and Diagrams tabs
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Pad
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewPadSettingsPanel extends ViewBase {
		/**
		 * @type any
		 */
		@Ref('settingsPanel')
		readonly settingsPanel!: any;

		/**
		 * The app version string to display in the About tab
		 *
		 * @type string
		 */
		@Prop({ default: '' })
		public version!: string;

		/**
		 * Active tab for the settings panel
		 *
		 * @type string
		 */
		protected settingsTab: string = 'About';

		/**
		 * Available tab configuration
		 *
		 * @type string[]
		 */
		protected settingsTabs: string[] = ['About', 'Settings', 'Diagrams'];

		/**
		 * Show the settings panel
		 *
		 * @return void
		 */
		public show(): void {
			this.settingsPanel.show();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle tab change within the settings panel
		 *
		 * @param string tab
		 * @return void
		 */
		protected Handle_OnTabChange(tab: string): void {
			this.settingsTab = tab;
		}

		// endregion: Event Handlers
	}
</script>
